export const Seasons_getTeamFromCompetingId = (competingTeams: ICompetingTeam[], id: string) => {
    if (competingTeams) {
        const team = competingTeams.find(t => t.id === id)
        if (team) return team
    }
    return null
}

export const Seasons_getDescription = (season: ISeason) => {
    if (season && season.season_number && season.start_date) {
        return season.season_number + ' - ' + season.start_date.toString().slice(0, 10)
    }
    return ''
}

export const Seasons_getEndDate = (season: ISeason) => {
    if (season && season.end_date) {
        return season.end_date.toString().slice(0, 10)
    }
    return 'No End Date'
}

export const Seasons_getCompetingTeamCompSeasonName = (
    competitions: ICompetition[],
    competing_team: ICompetingTeam
) => {
    let name = ''
    if (competing_team && 'id' in competing_team && competing_team?.competition_seasons?.length > 0) {
        const season = competing_team.competition_seasons[0]
        const competition = competitions.find(comp => comp.id === season.competition_id)
        if (season && competition) {
            name = `${competition.name}-${Seasons_getDescription(season)}`
        }
    }
    return name
}
